"use client";

import { useTranslations } from "next-intl";
import { useEffect, useState } from "react";
import IconSquareBehindSquare4 from "@ui/central-icons/icons/IconSquareBehindSquare4";
import IconCheckmark2 from "@ui/central-icons/icons/IconCheckmark2";
import { iconStrokeFix } from "@ui/central-icons/iconUtils";
import { clsx } from "clsx";

export function CopyButton({ text, variant = "elevated" }: { text: string; variant?: "secondary" | "elevated" }) {
  const t = useTranslations("ClientKeys.Globals");
  const [copyCount, setCopyCount] = useState(0);
  const copied = copyCount > 0;

  const icon = copied ? (
    <IconCheckmark2 className={clsx("tw-size-4", iconStrokeFix)} />
  ) : (
    <IconSquareBehindSquare4 className={clsx("tw-size-5", iconStrokeFix)} />
  );

  useEffect(() => {
    if (copyCount > 0) {
      const timer = window.setTimeout(() => {
        setCopyCount(0);
      }, 1500);
      return () => {
        window.clearTimeout(timer);
      };
    }
  }, [copyCount]);

  return (
    <button
      type='button'
      className={clsx(
        "tw-rounded-full tw-size-9 tw-flex tw-items-center tw-justify-center tw-transition-colors tw-outline-none focus-visible:tw-outline-focus",
        variant === "elevated" ? "tw-bg-white hover:tw-bg-gray-50" : "tw-bg-gray-50 hover:tw-bg-gray-100",
      )}
      style={{
        boxShadow:
          variant === "elevated"
            ? "0 0 1px 0 rgba(0, 0, 0, 0.40), 0 1px 1px 0 rgba(0, 0, 0, 0.04), 0 2px 4px 0 rgba(0, 0, 0, 0.04)"
            : undefined,
      }}
      onClick={() => {
        navigator.clipboard
          .writeText(text)
          .then(() => {
            setCopyCount(c => c + 1);
          })
          .catch(() => {});
      }}
      aria-label={copied ? t("copied") : t("copy")}
    >
      {icon}
    </button>
  );
}
